__turbopack_context__.v({
  "filter-sticky": "ProductList-module-scss-module__sN9oiG__filter-sticky",
});
